import React from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useBooking } from './BookingContext';

const STEPS = [
  { path: '/book/trips', label: 'Trips' },
  { path: '/book/seats', label: 'Seats' },
  { path: '/book/details', label: 'Details' },
  { path: '/book/payment', label: 'Pay' },
  { path: '/book/ticket', label: 'Ticket' },
];

function stepIndex(pathname) {
  const i = STEPS.findIndex((s) => pathname.startsWith(s.path));
  return i < 0 ? 0 : i;
}

export default function BookingLayout() {
  const booking = useBooking();
  const location = useLocation();
  const navigate = useNavigate();
  const current = stepIndex(location.pathname);

  const needsSearch = !booking.origin || !booking.destination || !booking.date;
  if (needsSearch && !location.pathname.startsWith('/book/ticket')) {
    return <Navigate to="/" replace />;
  }

  const leave = () => {
    booking.reset();
    navigate('/');
  };

  return (
    <div className="min-h-[70vh] bg-pink-50/40">
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between gap-3">
          <button
            type="button"
            onClick={() => (current === 0 ? leave() : navigate(-1))}
            className="text-sm font-semibold text-gray-700 hover:text-superfeo-pink"
          >
            ← Back
          </button>
          <h1 className="text-base md:text-lg font-heading font-bold text-gray-900 text-center">
            {STEPS[current]?.label || 'Booking'}
          </h1>
          <button
            type="button"
            onClick={leave}
            className="text-sm font-semibold text-superfeo-pink bg-pink-50 px-3 py-1.5 rounded-lg"
          >
            Home
          </button>
        </div>
        <div className="max-w-3xl mx-auto px-6 pb-4">
          <div className="flex items-center gap-1">
            {STEPS.map((step, i) => (
              <React.Fragment key={step.path}>
                {i > 0 && (
                  <div
                    className={`flex-1 h-0.5 ${
                      i <= current ? 'bg-superfeo-pink' : 'bg-gray-200'
                    }`}
                  />
                )}
                <div
                  className={`w-2.5 h-2.5 rounded-full shrink-0 ${
                    i <= current ? 'bg-superfeo-pink' : 'bg-gray-200'
                  }`}
                  title={step.label}
                />
              </React.Fragment>
            ))}
          </div>
          <div className="mt-2 flex justify-between text-[10px] sm:text-xs text-gray-500 font-medium">
            {STEPS.map((s) => (
              <span key={s.path}>{s.label}</span>
            ))}
          </div>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-4 py-6">
        <Outlet />
      </div>
    </div>
  );
}
